const localisations = {
    createButton: "Create",
    loading: "Loading...",
    pathLabel: "Partition Path",
    nameLabel: "Partition Name",
    nameHelperText: "The name associated with the partition",
    referenceLabel: "Partition Reference",
    referenceHelperText: "The reference associated with the partition",
    calloffCodeLabel: "Call-Off Code",
    calloffCodesTitle: "Call-Off Codes",
    emptyCallOffCodeTitle: "Call-off codes will appear here.",
    calloffCodeHelperText: "The Call-Off security code for the partition",
    generatedCallOffCodeButtonHelperText: "Auto generate call-off code",
    addCallOffCodeButtonHelperText: "Add call-off code",
    generateCalloffButtonLabel: "Generate",
    addCalloffButtonLabel: "add-call-off-code",
    ownerEmailLabel: "Project Manager Email",
    ownerEmailHelperText: "The email address of the partition owner",
    notesLabel: "Notes",
    notesHelperText: "Any additional notes?",
    partitionTable: {
        columns: {
            id: {
                headerName: "ID",
                description: "",
            },
            parentHierarchyNodeId: {
                headerName: "Parent Partition ID",
                description: "",
            },
            name: {
                headerName: "Name",
                description: "",
            },
            reference: {
                headerName: "Reference",
                description: "",
            },
            ownerEmail: {
                headerName: "Project Manager Email",
                description: "",
            },
            createdDateTime: {
                headerName: "Created",
                description: "Created Date and Time",
            },
        },
    },
    selector: {
        label: "Partition",
        placeholder: "Type to search",
        noOptionsLabel: "No Options",
        loadingLabel: "Loading...",
    },
};

export default localisations;
